// extracted by mini-css-extract-plugin
export default {"no-data-container":"NoDataRecord_no-data-container__2YZKV","image-holder":"NoDataRecord_image-holder__Wz1XL","no-data-message":"NoDataRecord_no-data-message__rxNza"};